import request from "./request.js";

export function getCheckManifest(access_token, job_id) {
  return request({
    url: "/check",
    method: "get",
    headers: {
      access_token,
    },
    params: {
      job_id,
    },
  });
}

export function getCheckResultPage(access_token, job_id, page, page_size = 20) {
  return request({
    url: "/check",
    method: "get",
    headers: {
      access_token,
    },
    params: {
      job_id,
      page,
      page_size,
    },
  });
}

export function getCheckDocResult(access_token, job_id, doc_id) {
  return request({
    url: "/check",
    method: "get",
    headers: {
      access_token,
    },
    params: {
      job_id,
      doc_id,
    },
  });
}

export default getCheckManifest;
